export const MapProperty = {
  // workbooks and classic, no need to change:
  ROUTING_CONTEXT: 'ROUTING_CONTEXT',
  TIMELINE_PLAYER_CURRENT_POINTS_OVERLAYS: 'timelinePlayerCurrentPointsOverlays',
  HIDPI: 'hidpi',
  PIXEL_RATIO: 'pixelRatio', // is also set in the OL Map constructor, but it is private and there is no getter, so we also add it as a map property
  PRIMARY_INTERACTION: 'primaryInteraction',

  // workbooks
  WORKBOOK_VIEW_ID: 'workbookViewId',
  IS_CLIENT_SIDE_RENDERING: 'isClientSideRendering',
  /**
   *  Whether to request exact coordinates of features for data view layers.
   *  Default is false, coordinates will be rounded by predefined precision in backend (e.g. 2 digits after decimal
   *  point for srs in meter). By geometry editing use exact coordinates.
   */
  EXACT_COORDINATES: 'exactCoordinates',
  /**
   * Legacy/deprecated: it is required for the MapFullscreenSidebarModalLegend in the fullscreen map dialogs,
   * as soon as we refactor it to not manage its own state or replace it with the new interactive legend,
   * this property can be cleaned up (please then also clean it up in the backend code).
   */
  INCLUDE_DETAILED_GROUP_LAYERS: 'includeDetailedGroupLayers',
  /**
   * For client-side export of external image layers, we need to set the crossOrigin property of the image elements
   * used to load the images to 'anonymous' in order to be able to access the pixel content of
   * the canvases where the images are drawn. Otherwise, the canvases are considered 'tainted'
   * and reading operations get blocked.
   *
   * For more details see: https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
   *
   * This is done through OpenLayer by setting the crossOrigin attribute of the sources. The property will be set to 'anonymous' if this flag is set to true on the map.
   * Currently supported are WMS and WMTS.
   */
  IS_CROSS_ORIGIN: 'isCrossOrigin', // used for export maps (cloned workbook map) where we need to set the cross-origin attribute of the image elements
  DRAW_STYLES: 'drawStyles', // Styles from map config, converted to OL style objects
  HIGHLIGHT_STYLES: 'highlightStyles', // Styles from map config, converted to OL style objects

  // should be migrated to workbook redux store
  /** In live mode, some operations like zooming etc. are still permitted. This flag
   * allows to distinguish between those that are triggered by live mode timer and
   * those that are triggered by the user.
   */
  IS_LIVE_MODE_REQUEST: 'IS_LIVE_MODE_REQUEST',
  PROJECTION_WKT: 'projectionWkt', // ! UNCLEAR if this won't cause GIS dependencies in workbook module on backend
  IS_FULL_SCREEN_MAP: 'isFullScreenMap', // whether the map is in the full screen dialog
  IS_OVERVIEW_MAP: 'iOverviewMap',

  // classic, needs to be removed in workbooks:
  ID: 'id',
  CONTEXT_URL: 'contextUrl', // will not be needed in workbooks when we change to map context building from workbook redux store
  OVERVIEW_MAP_DYNAMIC_EXTENT: 'overviewMapDynamicExtent', // as soon as we have coupled workbook overview map views
  OVERVIEW_MAP_DYNAMIC_ASPECT_RATIO: 'overviewMapDynamicAspectRatio', // as soon as we have coupled workbook overview map views
};
